export default __webpack_public_path__ + "static/media/caixa-seguradora-map.d1d5955c.png";